import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { getUser, getUserRoles } from '../../redux/auth/selectors';

export const PrivateRoute = ({ roles, children }) => {
  const user = useSelector(getUser);
  const userRoles = useSelector(getUserRoles);

  if (!user) {
    return <Navigate to={'/front/login'} />;
  }

  const isAuthorized = userRoles ? userRoles.some(role => roles.includes(role)) : false;

  if (!isAuthorized) {
    return <Navigate to={'/403'} />;
  }

  return children;
};
